import raterJs from "./index.js";

window.raterJs = raterJs;
